import type {Content} from '@prismicio/client'
import type {SliceComponentProps} from '@prismicio/react'
import type {FC} from 'react'
import type {Context} from 'src/common/types'
import {HeroAnimatedLinesBackground} from './variations/AnimatedBackgroundVariation'
import {HeroV3BrandFocus} from './variations/BrandFocusVariation'
import {CareersVariation} from './variations/CareersVariation'
import {HeroV3Default} from './variations/DefaultVariation'
import {HeroV3Pricing} from './variations/PricingVariation'

/**
 * Props for `HeroV3`.
 */
export type HeroV3Props = SliceComponentProps<Content.HeroV3Slice> & {context: Context}

/**
 * Component for "HeroV3" Slices.
 */
const HeroV3: FC<HeroV3Props> = ({slice, context, index: componentIndex}) => {
  switch (slice.variation) {
    case 'brandFocus':
      return <HeroV3BrandFocus slice={slice} context={context} componentIndex={componentIndex} />
    case 'default':
      return <HeroV3Default slice={slice} context={context} componentIndex={componentIndex} />
    case 'careersVariation':
      return <CareersVariation slice={slice} context={context} componentIndex={componentIndex} />
    case 'pricing':
      return <HeroV3Pricing slice={slice} context={context} componentIndex={componentIndex} />
    case 'animatedBackground':
      return <HeroAnimatedLinesBackground slice={slice} componentIndex={componentIndex} context={context} />
    default:
      return null
  }
}

export default HeroV3
